export default __webpack_public_path__ + "media/images/footer-facebook-social-c692c2e58bba411719337c5d96fc6971.svg";